lp.utils.openWorkWithAgentModal = function (modalOptions) {

	$('body').lpModal(
		$.extend(
			{
				onInit: true,
				width: 485,
				height: 650,
				src: '/ConnectAsCustomer/Register'
			},
			modalOptions
		)
	);

};
